<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19h3Uq8/tc-custom/9781497687424.jpg?1726871266303" alt="This image is the cover for the book Boston Blitz, The Executioner"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Boston Blitz, The Executioner
      </h1>
      <p class="bookDescription body article font2">
        <b>When his brother is kidnapped, the Executioner goes berserk</b><br/><br/> When the Pittsfield Mafia destroyed Mack Bolan’s family, the only survivor was his brother Johnny—a wide-eyed teen not prepared for life on the front lines of a war against the mob. Before he began his assault on organized crime, Mack sent Johnny into hiding along with Mack’s fiancée, Val. Now they’ve been kidnapped by an enterprising thug who thinks he can use the Executioner’s family against him. The Boston mob will pay for his mistake.<br/>  <br/> The city’s Mafia has splintered into factions, and Bolan is about to blow them wide open. He starts by marching into a few mob hangouts, killing the man in charge and demanding his brother back. When he learns that Johnny and Val might be dead, he loses it completely. When he’s being cautious, the Executioner is the deadliest man in America. Angry, he’s more trouble than an atomic bomb.<br/><br/> Boston Blitz <i>is the 12th book in the Executioner series, but you may enjoy reading the series in any order.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Don Pendleton
      </h2>
      
      <p class="authorDescription body article">Don Pendleton (1927&ndash;1995) was born in Little Rock, Arkansas. He served in the US Navy during World War II and the Korean War. His first short story was published in 1957, but it was not until 1967, at the age of forty, that he left his career as an aerospace engineer and turned to writing full time.&#160;After producing a number of science fiction and mystery novels, in 1969 Pendleton launched his first book in the Executioner saga:&#160;<I>War Against the Mafia</I>.&#160;The series, starring Vietnam veteran Mack Bolan, was so successful that it inspired a new American literary genre, and Pendleton became known as the father of action-adventure.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5d20a5bc